'use client';

import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { PieChart } from 'echarts/charts';
import { GridComponent, PolarComponent, TooltipComponent } from 'echarts/components';
import * as echarts from 'echarts/core';
import { SVGRenderer } from 'echarts/renderers';
import { type FC, useMemo } from 'react';
type Props = {
  data: {
    id: string;
    value: number;
    position: number;
    name: string;
  }[];
  color?: string;
};

// Register the required components
echarts.use([TooltipComponent, GridComponent, PolarComponent, PieChart, SVGRenderer]);
const getTotemOpacity = (position: number) => {
  switch (position) {
    case 1:
      return 1;
    case 2:
      return 0.8;
    case 3:
      return 0.6;
    default:
      return 0.2;
  }
};
const getTotemLabelSize = (position: number) => {
  switch (position) {
    case 1:
      return 22;
    case 2:
      return 18;
    case 3:
      return 16;
    default:
      return 14;
  }
};
const getTotemNameWithPosition = (position: number, name: string) => {
  switch (position) {
    case 1:
      return `1 | ${name}`;
    case 2:
      return `2 | ${name}`;
    case 3:
      return `3 | ${name}`;
    default:
      return name;
  }
};
export const HelioTotemsWheel: FC<Props> = (props: Props) => {
  const {
    data
  } = props;
  const theme = useTheme();
  const {
    i18n
  } = useLingui();
  const customData = useMemo(() => data.map(item => {
    return {
      value: 45,
      name: getTotemNameWithPosition(item.position, item.name),
      label: {
        fontSize: getTotemLabelSize(item.position)
      },
      itemStyle: {
        opacity: getTotemOpacity(item.position)
      }
    };
  }), [data]);
  const option = useMemo(() => {
    return {
      series: [{
        name: 'Second Cercle',
        type: 'pie',
        selectedMode: 'single',
        startAngle: 112,
        radius: [0, '70%'],
        label: {
          color: '#2D5B5B',
          position: 'inner',
          fontSize: 11,
          fontWeight: 'bold',
          width: 110,
          padding: [0, 0, 0, 12],
          // borderWidth: 2,
          // borderColor: 'red',
          overflow: 'break',
          opacity: 1
        },
        labelLine: {
          show: false
        },
        itemStyle: {
          color: theme.palette.primary.main,
          opacity: 0.2,
          borderColor: '#fff',
          borderType: 'solid',
          borderWidth: 4
        },
        data: [{
          value: 90,
          name: t`Développement personnel`
        }, {
          value: 68,
          name: t`Évolution`
        }, {
          value: 112,
          name: t`Ouverture aux autres`
        }, {
          value: 90,
          name: t`Continuité`
        }]
      }, {
        name: 'Totems',
        type: 'pie',
        radius: ['70%', '80%'],
        labelLine: {
          length: 30
        },
        label: {
          color: '#2D5B5B',
          fontWeight: 'bold',
          fontSize: 14,
          opacity: 1
          // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
          // backgroundColor: '#F6F8FC',
          // borderColor: '#8C8D8E',
          // borderWidth: 1,
          // borderRadius: 4,

          // rich: {
          //   a: {
          //     color: '#6E7079',
          //     lineHeight: 22,
          //     align: 'center',
          //   },
          //   hr: {
          //     borderColor: '#8C8D8E',
          //     width: '100%',
          //     borderWidth: 1,
          //     height: 0,
          //   },
          //   b: {
          //     color: '#4C5058',
          //     fontSize: 14,
          //     fontWeight: 'bold',
          //     lineHeight: 33,
          //   },
          //   per: {
          //     color: '#fff',
          //     backgroundColor: '#4C5058',
          //     padding: [3, 4],
          //     borderRadius: 4,
          //   },
          // },
        },
        itemStyle: {
          color: theme.palette.primary.main,
          borderColor: '#fff',
          borderType: 'solid',
          borderWidth: 4
        },
        data: customData
      }]
    };
  }, [customData, i18n.locale]);
  return <Box component="div" width="100%" height={{
    none: '300px',
    sx: '400px'
  }} sx={{
    pointerEvents: 'none'
  }} data-sentry-element="Box" data-sentry-component="HelioTotemsWheel" data-sentry-source-file="index.tsx">
      <ReactEChartsCore echarts={echarts} option={option} notMerge={true} lazyUpdate={true} theme={'theme_name'} style={{
      height: '100%',
      width: '100%'
    }} opts={{}} data-sentry-element="ReactEChartsCore" data-sentry-source-file="index.tsx" />
    </Box>;
};